'use strict'
const assign_ = require('lodash/assign')

const getErrorMessage = propertyName =>
  `Load message data must include ${propertyName} of type string`

const setExtraHeaders = (wixSdk, appLogger) => {
  try {
    self.elementorySupport.options = self.elementorySupport.options || {}
    self.elementorySupport.options.headers = assign_(
      {},
      self.elementorySupport.options.headers,
      { 'x-wix-site-revision': wixSdk.site.revision }
    )
  } catch (e) {
    appLogger.error(e)
  }
}

function setElementoryArguments(args) {
  if (!args.baseUrl || typeof args.baseUrl !== 'string') {
    throw new Error(getErrorMessage('baseUrl'))
  }
  if (!args.queryParameters || typeof args.queryParameters !== 'string') {
    throw new Error(getErrorMessage('queryParameters'))
  }

  if (!self.elementorySupport) {
    self.elementorySupport = {}
  }

  self.elementorySupport.baseUrl = args.baseUrl
  self.elementorySupport.queryParameters = args.queryParameters
  self.elementorySupport.options = assign_(
    {},
    self.elementorySupport.options,
    args.options
  )
}

module.exports = {
  setElementoryArguments,
  setExtraHeaders
}
